// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-ugw","controls":"styles_controls__1dpOw","charLimit":"styles_charLimit__vhqrX","input":"styles_input__28hSb","send":"styles_send__1SSYq"};